// #region CONSTANTES
export const RESSOURCE_ACHATS = "achats";
export const RESSOURCE_DETAIL_ACHATS = "detail_achats";
export const RESSOURCE_SERVICES = "services";
export const RESSOURCE_TARIFS = "tarifs";
export const RESSOURCE_ZONE = "zone_terminals";
// #endregion
